import type { FC } from 'react';
import { useEffect } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { useMiniLobbySlice } from '../../store/slices/minilobby/selectors';
import { miniLobbyActions } from '../../store/slices/minilobby/slice';
import { popupActions } from '../../store/slices/popup/slice';
import { PopupType } from '../popup/types';

import { SlotsLoader } from './SlotsLoader';

export const SlotsLoadingConnected: FC = () => {
  const isSlotsLobby = useConfigSlice.getIsSlotsLobby();
  const dispatch = useCoreDispatch();
  const isLoading = useMiniLobbySlice.getIsSlotsLobbyLoading();
  const hasError = useMiniLobbySlice.getIsSlotsLobbyHasError();
  const errorCount = useMiniLobbySlice.getSlotsLobbyErrorCount();

  if (!isSlotsLobby) return null;

  useEffect(() => {
    if (!isLoading) {
      dispatch(headerActions.setMiniLobbyOpen(false));
    }
  }, [dispatch, isLoading]);

  useEffect(() => {
    if (!hasError) return;

    const popupCode = errorCount < 2 ? 'LOBBY_TECHNICAL_ISSUE_TRY_AGAIN' : 'LOBBY_TECHNICAL_ISSUE_EXIT_GAME';

    dispatch(
      popupActions.pushPopupWithData({
        popupName: PopupType.Error,
        popupData: { code: popupCode },
      })
    );

    dispatch(miniLobbyActions.reSetSlotsLobbyError());
  }, [hasError, errorCount, dispatch]);

  if (isLoading) return <SlotsLoader />;

  return null;
};
